/**
 * Customer Select Modal Component - Using new Modal component
 */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalTitle,
} from '../../components/ui/modal';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { ScrollArea } from '../../components/ui/scroll-area';
import { Users } from 'lucide-react';

export function CustomerSelectModal({
  open,
  onOpenChange,
  customers,
  selectedCustomer,
  onSelect,
}) {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');

  const filteredCustomers = customers.filter(c =>
    c.name.toLowerCase().includes(search.toLowerCase()) ||
    c.phone?.includes(search)
  );

  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <ModalContent size="default">
        <ModalHeader>
          <ModalTitle className="flex items-center gap-2">
            <Users className="h-5 w-5" />
            {t('pdv.selectCustomer')}
          </ModalTitle>
        </ModalHeader>
        <ModalBody>
          <Input
            placeholder="Buscar cliente..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="mb-4"
          />
          <ScrollArea className="h-64">
            <div className="space-y-2">
              <Button
                variant={!selectedCustomer ? 'default' : 'outline'}
                className="w-full justify-start"
                onClick={() => onSelect(null)}
              >
                Sem cliente
              </Button>
              {filteredCustomers.map(customer => (
                <Button
                  key={customer.id}
                  variant={selectedCustomer?.id === customer.id ? 'default' : 'outline'}
                  className="w-full justify-start"
                  onClick={() => onSelect(customer)}
                  data-testid={`customer-${customer.id}`}
                >
                  <Users className="h-4 w-4 mr-2" />
                  <div className="text-left">
                    <p>{customer.name}</p>
                    {customer.phone && <p className="text-xs opacity-70">{customer.phone}</p>}
                  </div>
                </Button>
              ))}
            </div>
          </ScrollArea>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default CustomerSelectModal;
